'use strict';

function Bar2() {}


Bar2.prototype = {};


module.exports = Bar2;